import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import stashPaddleStyles from './StashPaddles.scss';
export const StashPaddle = (_param)=>{
    var { children, className, onClick, dataHook, disabled } = _param, rest = _object_without_properties(_param, [
        "children",
        "className",
        "onClick",
        "dataHook",
        "disabled"
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(stashPaddleStyles['duper'], className, !disabled && stashPaddleStyles['enabled']),
        "data-hook": dataHook
    }, /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        onClick: onClick,
        type: "button",
        disabled: disabled
    }, rest), children));
};
StashPaddle.displayName = 'StashPaddle';
export default StashPaddle;
